import { createAction, props } from "@ngrx/store";
import { AuthRequest } from "../models/auth-request";
import { AuthResponse } from "../models/auth-response";
import { APIResponse } from "src/app/core/models/api-response";
import { AppError } from "src/app/core/models/api-error";
import { MfaChallenge } from "../models/mfa-challenge";

export const LoginAction = createAction(
  '[ Auth ] - Login',
  props<{ payload: AuthRequest }>()
);
export const LoginActionSuccess = createAction(
  '[ Auth ] - Login Success ',
  props<{ payload: APIResponse<AuthResponse> }>()
);

/** Carries the failure so the page can keep showing it. Without a payload the
 *  reducer had nothing to store and the only trace was a toast that faded
 *  while the user was still retyping. */
export const LoginActionError = createAction(
  '[ Auth ] - Login Error',
  props<{ error: AppError }>()
);

/**
 * Password accepted, second factor owed. Not LoginActionSuccess: the three
 * effects hanging off that action have no session to hydrate from.
 */
export const MfaChallengeRequired = createAction(
  '[ Auth ] - MFA Challenge Required',
  props<{ challenge: MfaChallenge }>()
);

/** Submit a second-factor code against the challenge held in state. */
export const MfaVerifyAction = createAction(
  '[ Auth ] - MFA Verify',
  props<{ code: string }>()
);

/** Ask for a one-time code by email on the open challenge. */
export const MfaSendEmailCode = createAction('[ Auth ] - MFA Send Email Code');

export const MfaEmailCodeSent = createAction(
  '[ Auth ] - MFA Email Code Sent',
  props<{ nextAllowedAt: string; maskedEmail: string }>()
);

/** A failed send. Separate from LoginActionError, which the challenge screen
 *  treats as a refused code and clears the field for. */
export const MfaSendEmailCodeError = createAction(
  '[ Auth ] - MFA Send Email Code Error',
  props<{ error: AppError }>()
);

/** The challenge outlived its token. The backend answers a stale one with the
 *  same 401 as a wrong code, so nothing else tells the user their time is up. */
export const MfaChallengeExpired = createAction('[ Auth ] - MFA Challenge Expired');

/** Abandon the challenge and go back to the credentials form. */
export const MfaChallengeCleared = createAction('[ Auth ] - MFA Challenge Cleared');

// loading actions
export const SetAuthLoading = createAction(
  '[ Auth ] - Set Loading',
  props<{ isLoading: boolean }>()
);

// rest pwd
export const ForgetPasswordAction = createAction(
  '[Auth] Forget Password',
  props<{ payload: { email: string, database?: string } }>()
);
export const ForgetPasswordError = createAction(
  '[Auth] Forget Password Error',
  props<{ error: string }>()
);
export const ResetPasswordAction = createAction(
  '[Auth] Reset Password',
  props<{ payload: { newPassword: string,confirm_password: string, token:string } }>()
);

export const ResetPasswordError = createAction(
  '[Auth] Reset Password Error',
  props<{ error: string }>()
)